<template>
    <div class="about-content">
        <!-- <div id="abouttop" class="about-content-top">
            <img src="/static/images/about/about-img.png">
        </div> -->
        <div id="companyinfo" class="about-content-list">
            <div class="title">
                <ul>
                    <li class="title-ch"><span>公司简介</span></li>
                </ul>
            </div>
            <div class="info">
                <p v-for="(item,index) in companyProfile.paragraph" :key="index">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{item.content}}
                </p>
            </div>
        </div>
        <div id="honor" class="about-content-list" style="background:#f3f3f3">
            <div class="title">
                <ul>
                    <li class="title-en"></li>
                    <li class="title-ch"><span>资质荣誉</span></li>
                </ul>
            </div>
            <div class="info">
                <img src="/static/images/about/honorary.png">
            </div>
        </div>
        <div id="culture" class="about-content-list">
            <div class="title">
                <ul>
                    <li class="title-ch"><span>企业文化</span></li>
                </ul>
            </div>
            <div class="info" style="width:100%;">
                <div class="info-img">
                    <img  src="/static/images/about/corporate-culture.png">
                    <ul class="corporate-culture-ul">
                        <li class="corporate-culture-li" v-for="(item,index) in corporateCulture" :key="index">
                            <div class="corporate-culture-content-title">
                                <img :src="item.icon" />
                                <p>{{item.title}}</p>
                            </div>
                            <div class="corporate-culture-content-line">
                                <i></i>
                            </div>
                            <div class="corporate-culture-content-value">
                                {{item.content}}
                            </div>
                            <!-- <div class="corporate-culture-content-area">
                                
                            </div> -->
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div id="join" class="about-content-list">
            <div class="title">
                <ul>
                    <li class="title-ch"><span>加入我们</span></li>
                </ul>
            </div>
            <div class="info">
                <ul class="join-us-ul">
                    <li class="join-us-li" v-for="(item,index) in joinUsData" :key="index" onselectstart="return false;">
                        <div class="join-us-title">
                            <div class="li-area position">{{item.position}}</div>
                            <div class="li-area experience">{{item.experience}}</div>
                            <div class="li-area education">{{item.education}}</div>
                            <div class="li-area quantity">{{item.quantity}}</div>
                            <div class="li-area address">{{item.address}}</div>
                            <div class="li-area switch " :class="item.show? 'switch-top-icon' : 'switch-bottom-icon' " @click="switchEvent(item)"></div>
                        </div>
                        <div v-if="item.show" class="join-us-default">
                            <div class="join-us-default-content">
                                <div class="join-us-default-work-content">
                                    <div class="join-us-default-work-content-title">工作内容</div>
                                    <div class="join-us-default-work-content-list">
                                        <ul>
                                            <li v-for="(contentItem , index) in item.content" :key="index">{{index + 1}}.{{contentItem.content}}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="join-us-default-work-content">
                                    <div class="join-us-default-work-content-title">任职要求</div>
                                    <div class="join-us-default-work-content-list">
                                        <ul>
                                            <li v-for="(askItem , index) in item.ask" :key="index">{{index + 1}}.{{askItem.content}}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="join-us-default-apply-btn">
                                <input type="button" value="申请投递" />
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div id="contact" class="about-content-list">
            <div class="title">
                <ul>
                    <li class="title-ch"><span>联系我们</span></li>
                </ul>
            </div>
            <div class="info" style="width:100%">
                <div class="info-img">
                    <img src="/static/images/about/contact-us-icon.png">
                    <div class="contact-us-area">
                        <div class="contact-us-address">
                            <div class="contact-us-img">
                                <img :src="contactUs.address.img" alt="">
                            </div>
                            <div class="contact-us-value">地址：{{contactUs.address.value}}</div>
                        </div>
                        <div class="contact-us-zipcode">
                            <div class="contact-us-img">
                                <img :src="contactUs.zipcode.img" alt="">
                            </div>
                            <div class="contact-us-value">邮编：{{contactUs.zipcode.value}}</div>
                        </div>
                        <div class="contact-us-phone">
                            <div class="contact-us-img">
                                <img :src="contactUs.phone.img" alt="">
                            </div>
                            <div class="contact-us-value">电话：{{contactUs.phone.value}}</div>
                        </div>
                    </div>
                </div>
                <div class="info" style="margin-bottom:5rem;">
                    <div class="info-img" style="margin-top:10rem; height:40rem;overflow: hidden;">
                        <iframe style="width:100%;height:100%;border:0" src="/static/html/map.html" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            companyProfile:dataconfig.about.companyProfile,
            corporateCulture:dataconfig.about.corporateCulture,
            joinUsData:dataconfig.about.joinUsData,
            contactUs:dataconfig.about.contactUs
        }
    },
    mounted(){
        let me = this;
        me.bus.$on("scrollIntoView",(item) =>{
            me.scrollIntoViewEvent(item.id);
        });
    },
    methods:{
        switchEvent(item){
            let me = this;
            item.show = !item.show;
        },
        scrollIntoViewEvent(id){
            document.getElementById(id).scrollIntoView({
                behavior: 'smooth'
            });
        }
    }
}
</script>
<style scoped>
    .about-content{
        width: 100%;
        height: auto;
        background: #fafafc;
    }
    .about-content-top{
        width: 100%;
        height: 30rem;
    }
    .about-content-top img{
        width: 100%;
        height:100%;
    }
    .about-content-list{
        width: 100%;
        height:auto;
        background: #fafafc;
    }
    .title{
        width: 100%;
        height: var(--product-top-height);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .title ul{
        list-style: none;
        padding:0;
        margin:0;
        width: auto;
        height: auto;
    }
    .title-en{
        width: 100%;
        height:auto;
        font-size: 1.5vw;
        font-weight: bold;
        letter-spacing: 3px;
        padding:2px;
    }
    .title-ch {
        width: auto;
        height:auto;
        font-size: 1.5vw;
        padding:2px;
        position: relative;
        margin: 0 auto;
        text-align: center;
    }
    .title-ch::before{
        content: "";
        width: 25px;
        height: 0;
        border:1px solid red;
        position: absolute;
        left:-40px;
        top:50%;
    }
    .title-ch::after{
        content: "";
        width: 25px;
        height: 0;
        border:1px solid red;
        position: absolute;
        right:-40px;
        top:50%;
    }
    .info{
        width: 80%;
        height: auto;
        margin:0 auto;
        overflow: hidden;
    }
    .info img{
        width: 100%;
    }
    .info p{
        line-height: 30px;
        font-size: 1rem;
        letter-spacing: 2px;
        color:#181818;
    }
    .info-img{
        width:100%;
        height:30rem;
        overflow: hidden;
        position: relative;
    }
    .info-img > img{
        width: 100%;
        height: 100%;
    }
    .corporate-culture-ul{
        width: 100%;
        height:100%;
        list-style: none;
        margin:0;
        padding:0;
        position: absolute;
        top: 0;
    }
    .corporate-culture-li{
        height: 100%;
        float: left;
        width: calc(100% / 4);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        cursor: default;
        transition: all 0.5s;
        background: linear-gradient(to right,rgba(137, 25, 30, 0.5),rgba(137, 25, 30, 0.5)) no-repeat right;
        background-size: 0 100%;
        transition:background-size 800ms , color 800ms;
        overflow: hidden;
    }
    .corporate-culture-li:hover{
        /* background: rgba(137, 25, 30, 0.5); */
        background-position-x:left !important;
        background-size: 100% 100% !important;
    }
    .corporate-culture-li:hover .corporate-culture-content-value{
        height: auto;
    }
    .corporate-culture-content-area{
        width: 80%;
        height:40%;
    }
    .corporate-culture-content-title{
        width: 100%;
        height:auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .corporate-culture-content-title > img{
        width: 40px;
    }
    .corporate-culture-content-title p{
        font-size: 1.8rem;
        color:#fff;
        margin-left:10px;
    }
    .corporate-culture-content-line{
        width: 100%;
        height:auto;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px
    }
    .corporate-culture-content-line i{
        display: block;
        width: 5rem;
        height: 0;
        border:1px solid #fff;
    }
    .corporate-culture-content-value{
        max-width: 70%;
        height: 0;
        color:#fff;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 1rem;
        line-height: 2rem;
        letter-spacing: 2px;
        transition: all 0.5s;
        overflow: hidden;
        transition:height 800ms
    }
    .join-us-ul{
        width: 100%;
        height: auto;
        list-style: none;
        margin: 0;
        padding: 0;
    }
    .join-us-li{
        width: 100%;
        min-height: 7rem;
        height: auto;
        background: #fff;
        margin:15px auto;
        cursor: default;
        border-radius: 5px;
    }
    .join-us-li .li-area{
        float: left;
        height: 100%;
        letter-spacing: 1px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        line-height: 7rem;
    }
    .join-us-title{
        width: 100%;
        height: 7rem;
    }
    .join-us-title:hover .position,.join-us-title:hover .experience,.join-us-title:hover .education,.join-us-title:hover .quantity,.join-us-title:hover .address{
        color:red;
    }
    .position{
        width: calc(30% - 50px);
        font-weight: 600;
        font-size: 1.1rem;
        padding-left:50px;
        color:#333;
        font-family: Source Han Sans CN Medium, Source Han Sans CN Medium-Medium;
    }
    .experience{
        width: 15%;
        color:#666666;
        position: relative;
        text-align: center;
    }
    .experience::after{
        content: '/';
        position: absolute;
        right:0;
        font-size: 20px;
        color:#ccc;

    }
    .education{
        width: 15%;
        color:#666666;
        position: relative;
        text-align: center;
    }
    .education::after{
        content: '/';
        position: absolute;
        right:0;
        font-size: 20px;
        color:#ccc;

    }
    .quantity{
        width: 10%;
        color:#666666;
        position: relative;
        text-align: center;
    }
    .quantity::after{
        content: '/';
        position: absolute;
        right:0;
        font-size: 20px;
        color:#ccc;

    }
    .address{
        width: calc(20% - 50px);
        color:#666666;
        padding-left:50px;
    }
    .switch{
        width: 10%;
        color:#666666;
        position: relative;
        font-size: 20px;
        cursor: pointer;
        text-align: center;
    }
    .switch-bottom-icon::after{
        content: '';
        width: 0;
        height: 0;
        border:10px solid transparent;
        border-top-color: #999;
        position: absolute;
        top: 3.1rem;
    }
    .switch-top-icon::after{
        content: '';
        width: 0;
        height: 0;
        border:10px solid transparent;
        border-bottom-color: #999;
        position: absolute;
        bottom: 3.1rem;
    }
    
    .join-us-default{
        width: 100%;
        height: auto;
        border-top:1px solid #ccc;
    }
    .join-us-default-content{
        width: calc(100% - 100px);
        height: auto;
        padding:20px 50px;
        overflow: hidden;
    }
    .join-us-default-work-content{
        width: 100%;
        height: auto;
        margin-top:30px;
        overflow: hidden;
    }
    .join-us-default-work-content-title{
        float: left;
        width: 10%;
        height: auto;
        color:#333;
        font-weight: bold;
    }
    .join-us-default-work-content-list{
        float: left;
        width: 90%;
        height: auto;
    }
    .join-us-default-work-content-list ul{
        width: 100%;
        height:auto;
        list-style: none;
        padding:0;
        margin:0;
    }
    .join-us-default-work-content-list ul li{
        width: 100%;
        height: 35px;
        color:#666;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        letter-spacing: 1px;
        font-size: 1rem;
    }
    .join-us-default-apply-btn{
        width: calc(100% - 100px);
        height: auto;
        padding:50px;
    }
    .join-us-default-apply-btn input{
        width: 12rem;
        height:3.5rem;
        border:0;
        background: red;
        color:#fff;
        font-size: 1rem;
        letter-spacing: 1px;
        cursor: pointer;
        border-radius: 5px;
    }
    .contact-us-area{
        width: 100%;
        height: 100%;
        position: absolute;
        top:0;
        display: flex;
        align-items: center;
    }
    .contact-us-address{
        width: 40%;
        height: 40%;
        float: left;
    }
    .contact-us-zipcode{
        width: 25%;
        height: 40%;
        float: left;
    }
    .contact-us-phone{
        width: 35%;
        height: 40%;
        float: left;
    }
    .contact-us-img{
        width: 100%;
        height: 65%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }
    .contact-us-img img{
        width: 7rem;
    }
    .contact-us-value{
        width: 100%;
        height: 35%;
        display: flex;
        justify-content: center;
        align-items: center;
        color:#fff;
    }
</style>


// WEBPACK FOOTER //
// src/view/page/about.vue